import {
    MovieOnlineStreamsFragment,
    MovieStreamFragment,
    MovieWatchParamsFragment,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { PreferredTracks } from '@/scenarios/legacy-player/types/config';

import { isPrimaryLang } from '../../Player/lib/utils/trackLanguage';

interface GetPreferredTracksProps {
    watchParams: MovieWatchParamsFragment['watchParams'] | undefined;
    onlineStreams: MovieOnlineStreamsFragment | undefined;
    getDefaultAudio?: (streams: MovieStreamFragment) => string | undefined;
}

export const getPreferredTracks: (props: GetPreferredTracksProps) => PreferredTracks = ({
    watchParams,
    onlineStreams,
    getDefaultAudio,
}): PreferredTracks => {
    const { streams, playerRestrictionConfig } = onlineStreams || {};

    if (!streams?.[0] || !playerRestrictionConfig) {
        return {
            textTrackLang: undefined,
            audioTrackLang: undefined,
            videoTrackLabel: undefined,
        };
    }

    const {
        audioLanguage: audioLanguageFromWatchParams,
        subtitleLanguage: subtitleLanguageFromWatchParams,
    } = watchParams || {};

    const { subtitlesButtonEnable } = playerRestrictionConfig || {};

    const firstAudioLanguage = streams[0]?.streamMeta?.audioMetas[0]?.language;
    const firstSubtitleLanguage = streams[0]?.streamMeta?.subtitleMetas[0]?.language ?? undefined;

    const audioLanguage =
        audioLanguageFromWatchParams ?? getDefaultAudio?.(streams[0]) ?? firstAudioLanguage;

    let subtitleLanguage: string | undefined = subtitleLanguageFromWatchParams ?? undefined;

    if (audioLanguage && !isPrimaryLang(audioLanguage) && !subtitlesButtonEnable) {
        subtitleLanguage = subtitleLanguage ?? firstSubtitleLanguage;
    }

    return {
        audioTrackLang: audioLanguage,
        textTrackLang: subtitleLanguage,
        videoTrackLabel: undefined,
    };
};
